<script>
import Treeselect from '@riophae/vue-treeselect'

export default {
  name: 'BaseTreeSelect',
  components: { Treeselect },
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    vuelidate: {
      type: Object,
      default: () => {},
    },
    required: Boolean,
  },
  computed: {
    hasErrors() {
      return this.vuelidate && this.vuelidate.$error
    },
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update', val)
      },
    },
  },
  methods: {
    onInput() {
      this.vuelidate && this.vuelidate.$touch()
    },
  },
}
</script>

<template>
  <BaseFormGroup
    :required="required"
    :label="label"
    :vuelidate="vuelidate"
    :has-errors="hasErrors"
  >
    <Treeselect
      v-model="inputVal"
      :class="{ 'vue-treeselect--invalid': hasErrors }"
      :open-on-focus="true"
      :options="options"
      v-bind="$attrs"
      @input="onInput"
      v-on="$listeners"
    >
      <label slot="option-label" slot-scope="{ node }">
        {{ node.raw.name }}
      </label>
      <div slot="value-label" slot-scope="{ node }">
        {{ node.raw.name }}
      </div>
    </Treeselect>
    <template v-slot:errors>
      <slot name="errors" />
    </template>
  </BaseFormGroup>
</template>

<style lang="scss" scoped>
/* stylelint-disable */
.vue-treeselect {
  &::v-deep {
    .vue-treeselect__control {
      @apply w-full px-5 font-hairline leading-loose border outline-none appearance-none border-gray-light shadow-input text-blue-darker text-basel rounded-input bg-white-transparent;
    }
  }

  &--invalid::v-deep .vue-treeselect__control {
    @apply border-volunteer_red;
  }

  &--focused::v-deep .vue-treeselect__control {
    @apply rounded-b-none border-gray;
  }

  &:not(.vue-treeselect--disabled):not(.vue-treeselect--invalid):not(.vue-treeselect--focused)::v-deep
    .vue-treeselect__control:hover {
    @apply border-gray-light;
  }
}
/* stylelint-enable */
</style>
